export default "a-default3";



// WEBPACK FOOTER //
// ./src/mod9.js